import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { BeniMobiliFormComponent } from '../../../form/beni-mobili-form.component';
import { BeneMobile } from '../../../models/bene-mobile/bene-mobile';
import { BeniMobiliResponse } from '../../../models/dto/beni-mobili-response';
import { SezioneBeniMobili } from '../../../models/sezioni/sezione-beni-mobili';
import { FormValidationService } from '../../../services/form-validation.service';

@Component({
    selector: 'div [beni-mobili-form-add]',
  templateUrl: '../../../form/beni-mobili-form.html'
})
export class BeniMobiliAddComponent extends BeniMobiliFormComponent {
  urlAddBene: string;
  idFascicolo: string;
  idSezione: string;
  @Output()
    onReturn: EventEmitter<SezioneBeniMobili> = new EventEmitter<SezioneBeniMobili>();

  constructor(@Inject(OperationsService) operationService: OperationsService,
              @Inject(FormBuilder) campiForm,
              @Inject(HelpersService) helpers: HelpersService,
              @Inject(FormValidationService) formValidationService: FormValidationService) {
        super(operationService, campiForm, helpers, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Aggiungi bene pignorato - mobile');
    this.isInserimento(true);
  }

  getBeneMobile(): BeneMobile {
    return new BeneMobile();
  }

  getRequest(beneMobile: BeneMobile) {
    this.operationService.createBeneMobile(this.urlAddBene, this.idFascicolo, this.idSezione, beneMobile).subscribe(response => this.beneMobileCreated(response));
  }

  beneMobileCreated(response: BeniMobiliResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(urlAddBene: string, idFascicolo: string, idSezione) {
    this.urlAddBene = urlAddBene;
    this.idFascicolo = idFascicolo;
    this.idSezione = idSezione;
    this.populateSelect();
    this.createForm();
  }
}
